exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* Theme Colors */\n.history-filter-form {\n  display: flex;\n  gap: 16px;\n  margin-bottom: 24px;\n}\n.history-filter-form .ant-form-item {\n  margin-right: 0;\n}\n.history-filter-form .history-filter-tooltip {\n  margin-left: 8px;\n  vertical-align: middle;\n}\n", ""]);

// exports
